import { licencesTypes } from 'shared/constants/licencesTypes';
import { organisationAdmin } from 'shared/constants/rolesTypes';
import { moduleRoutes } from 'shared/constants/moduleRoutes';
import { API_URL } from 'utils';

export const permissionsService = async ({ token, roles, licences }) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  const authParams = {
    headers: {
      ...headers,
      authorization: `Bearer ${token}`,
    },
    method: 'GET',
  };

  const verifyAccess = (value, access) =>
    access.includes(value)
      ? fetch(
          `${API_URL}/${moduleRoutes[value]}/permissions?roles=${roles.join()}`,
          authParams,
        ).then(res => res.ok && res.json())
      : false;

  const adminPermissionsCall = verifyAccess(organisationAdmin, roles);
  const investorhubPermissionsCall = verifyAccess(licencesTypes.INVESTORHUB_MODULE, licences);
  const analyticalOperationsPermissionsCall = verifyAccess(
    licencesTypes.ANALYTICALOPERATIONS_MODULE,
    licences,
  );
  const riskAnalysisPermissionsCall = verifyAccess(licencesTypes.RISKANALYSIS_MODULE, licences);

  const [
    adminPermissions,
    investorhubPermissions,
    analyticalOperationsPermissions,
    riskAnalysisPermissions,
  ] = await Promise.all([
    adminPermissionsCall,
    investorhubPermissionsCall,
    analyticalOperationsPermissionsCall,
    riskAnalysisPermissionsCall,
  ]);

  const parsePermissions = (permissions, module) =>
    permissions && {
      [`${module}_PERMISSIONS`]: permissions.data.map(permission => ({
        [permission]: true,
      })),
    };

  return {
    permissions: {
      ...parsePermissions(adminPermissions, licencesTypes.ADMIN_MODULE),
      ...parsePermissions(investorhubPermissions, licencesTypes.INVESTORHUB_MODULE),
      ...parsePermissions(
        analyticalOperationsPermissions,
        licencesTypes.ANALYTICALOPERATIONS_MODULE,
      ),
      ...parsePermissions(riskAnalysisPermissions, licencesTypes.RISKANALYSIS_MODULE),
    },
  };
};
